import { useState } from 'react';
import { TextButton } from '../../../Atoms/TextButton';
import { useEngagementEditor } from './EngagementEditorContext';

export const CountLineItemsButton = ({ supplierId, disabled = false }: { supplierId: string; disabled?: boolean }) => {
  const { currentSuppliers } = useEngagementEditor();
  const [saving, setSaving] = useState(false);

  const count = async () => {
    setSaving(true);
    try {
      await currentSuppliers?.countLineItems(supplierId);
    } finally {
      setSaving(false);
    }
  };

  return (
    <TextButton
      className="self-start"
      disabled={saving || disabled}
      onClick={count}>
      count invoice line items instead
    </TextButton>
  );
};
